'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _blacklist = require('blacklist');

var _blacklist2 = _interopRequireDefault(_blacklist);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var FormField = require('./FormField');

var FormFieldAddOn = (function (_React$Component) {
    _inherits(FormFieldAddOn, _React$Component);

    function FormFieldAddOn() {
        _classCallCheck(this, FormFieldAddOn);

        _get(Object.getPrototypeOf(FormFieldAddOn.prototype), 'constructor', this).apply(this, arguments);
    }

    _createClass(FormFieldAddOn, [{
        key: 'render',
        value: function render() {
            // props
            var props = (0, _blacklist2['default'])(this.props, 'children', 'leadingNodes', 'trailingNodes', 'separator');

            // classes
            var fieldClass = (0, _classnames2['default'])('FormFieldAddOn');
            var trailingClass = (0, _classnames2['default'])('trailingNode', this.props.separator ? 'separator-right' : null);
            var leadingClass = (0, _classnames2['default'])('leadingNode', this.props.separator ? 'separator-left' : null);

            var leadingNodes = [];
            this.props.leadingNodes.map(function (node, i) {
                leadingNodes.push(_react2['default'].createElement(
                    'span',
                    { key: i, className: leadingClass },
                    node,
                    ' '
                ));
            });

            var trailingNodes = [];
            this.props.trailingNodes.map(function (node, i) {
                trailingNodes.push(_react2['default'].createElement(
                    'span',
                    { key: i, className: trailingClass },
                    node,
                    ' '
                ));
            });

            var leading = _react2['default'].createElement(
                'span',
                { className: 'leadingNodes' },
                leadingNodes
            );

            var trailing = _react2['default'].createElement(
                'span',
                { className: 'trailingNodes' },
                trailingNodes,
                ' '
            );

            return _react2['default'].createElement(
                FormField,
                props,
                _react2['default'].createElement(
                    'div',
                    { className: fieldClass },
                    this.props.children,
                    trailing,
                    leading
                )
            );
        }
    }]);

    return FormFieldAddOn;
})(_react2['default'].Component);

FormFieldAddOn.propTypes = {
    className: _propTypes2['default'].string,
    leadingNodes: _propTypes2['default'].node,
    separator: _propTypes2['default'].bool,
    trailingNodes: _propTypes2['default'].node
};

FormFieldAddOn.defaultProps = {
    leadingNodes: [],
    trailingNodes: []
};

module.exports = FormFieldAddOn;


//////////////////
// WEBPACK FOOTER
// /causemisspiggynodeweb-ci-9188/workspace/Release/~/kepler/lib/components/FormFieldAddOn.js
// module id = 304
// module chunks = 0